import 'dayjs/locale/pt-br';
// PLUGINS
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
//

dayjs.extend(relativeTime);
dayjs.extend(calendar);
dayjs.extend(duration);

dayjs.extend(updateLocale);

dayjs.locale('pt-br');
dayjs.updateLocale('pt-br', {
  calendar: {
    lastDay: '[Ontem]',
    sameDay: 'HH:mm',
    nextDay: '[Amanhã]',
    lastWeek: 'DD/MM/YYYY',
    nextWeek: 'DD/MM/YYYY',
    sameElse: 'DD/MM/YYYY',
  },
});

export default dayjs;
